import React from "react";

import { useState } from "react";
import FormFields from "./FormFields";
import Button from "../Button";
import * as RadixForm from "@radix-ui/react-form";
import { SubmitHandler, useFormContext } from "react-hook-form";
import { useSignUpForm } from "./SignUpFormContext";
import { SignUpFormData } from "../../SignUpFormTypes/signUpFormTypes";
import { getDataForSubmission, removeValueFromPassword } from "./signUpHelpers";
import LoadingSpinner from "../LoadingSpinner";
import { useKount } from "../../../../../hooks/useKount";
import { Cookie } from "../../../../../utils/Cookie";

const Form = () => {
  const {
    handleSubmit,
    formState: { isValid: allowNext, ...formState },
    trigger,
    getValues,
  } = useFormContext<SignUpFormData>();

  const {
    getCurrentStep,
    getIsLastStep,
    next,
    promoCode,
    deleteCookieFromBaseDomain,
    handleSetCookie,
    startTime,
    currentStep,
    signUpStepCompleted,
    onSubmitForm,
    reCaptchaRef,
    lastStepCta,
    steps,
  } = useSignUpForm();
  const [submittingForm, setSubmittingForm] = useState(false);
  const { setValue } = useFormContext<SignUpFormData>();

  const step = getCurrentStep();
  const lastStep = getIsLastStep();
  const btnTxt = lastStep ? lastStepCta || "Start free trial now" : "Next";
  const kountSessionId = useKount();

  const onSubmit: SubmitHandler<SignUpFormData> = (formValues, event) => {
    event?.preventDefault();
    if (allowNext && !lastStep) {
      next(btnTxt, formValues.email);
      removeValueFromPassword(steps, currentStep, setValue, true);
      trigger();
      return;
    }

    setSubmittingForm(true);

    const finalTime = Math.floor((Date.now() - startTime) / 1000);
    const offerPromoCode = getValues("promoCode");

    if ((offerPromoCode || promoCode) && lastStep) {
      deleteCookieFromBaseDomain("PROMOCODE");
      handleSetCookie("PROMOCODE", offerPromoCode || promoCode || "");
    }

    const formData = {
      ...getDataForSubmission(formValues),
      clickedPlan: Cookie.getCookie("clickedPlan"),
      gclid: Cookie.getCookie("gclid"),
      kountSessionId: null,
    };

    onSubmitForm({
      formData,
      recaptchaRef: reCaptchaRef,
      finalTime,
      kountSessionId,
    }).finally(() => {
      signUpStepCompleted({
        fields: step?.fields,
        step: currentStep + 1,
      });
      setSubmittingForm(false);
    });
  };

  return (
    <RadixForm.Root
      className="flex flex-col items-center gap-8 self-stretch"
      onSubmit={handleSubmit(onSubmit)}
    >
      <FormFields fields={step?.fields} />
      <Button
        disabled={!allowNext || submittingForm}
        customClassName="sm:-mt-2"
        type="submit"
      >
        {submittingForm ? <LoadingSpinner /> : btnTxt}
      </Button>
    </RadixForm.Root>
  );
};

export default Form;
